import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, HeartPulse, Navigation, Star } from "lucide-react";
import { NAV, CLINIC } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative grain overflow-hidden bg-brand-deep text-mint/90"
    >
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <span className="grid place-items-center w-9 h-9 rounded-full bg-brand text-white">
                <HeartPulse size={18} />
              </span>
              <span className="font-display text-2xl font-semibold text-white">Dr. Pallavi Mishra</span>
            </Link>
            <p className="text-sm leading-relaxed text-mint/70 max-w-xs">
              Consultant Cardiologist in Varanasi focused on preventive, non-invasive and patient-centric cardiac care.
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.22em] text-brand font-bold mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-mint/75 hover:text-white transition-colors duration-300"
                    data-testid={`footer-link-${item.to === "/" ? "home" : item.to.replace("/", "")}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-5">
            <h4 className="text-xs uppercase tracking-[0.22em] text-brand font-bold mb-5">Visit / Contact</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin size={18} className="text-brand shrink-0 mt-0.5" />
                <span className="text-mint/80">{CLINIC.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone size={18} className="text-brand shrink-0 mt-0.5" />
                <a href={`tel:+${CLINIC.phoneRaw}`} className="text-mint/80 hover:text-white transition-colors">{CLINIC.phone}</a>
              </li>
              <li className="flex gap-3">
                <Mail size={18} className="text-brand shrink-0 mt-0.5" />
                <a href={`mailto:${CLINIC.email}`} className="text-mint/80 hover:text-white transition-colors">{CLINIC.email}</a>
              </li>
              <li className="flex gap-3">
                <Clock size={18} className="text-brand shrink-0 mt-0.5" />
                <span className="text-mint/80">
                  {CLINIC.hours.map((h) => (
                    <span key={h.day} className="block">
                      {h.day}: <span className="text-mint/60">{h.time}</span>
                    </span>
                  ))}
                </span>
              </li>
            </ul>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href={CLINIC.directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-directions-btn"
                className="inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark text-white px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] transition-colors duration-300"
              >
                <Navigation size={14} /> Get Directions
              </a>
              <a
                href={CLINIC.reviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-reviews-btn"
                className="inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-white text-white px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] transition-colors duration-300"
              >
                <Star size={14} /> Reviews
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-mint/50">
            © {new Date().getFullYear()} Dr. Pallavi Mishra Cardiology Clinic, Varanasi. All rights reserved.
          </p>
          <p className="text-xs text-mint/40">
            Preventive · Non-Invasive · Women&rsquo;s Heart Care
          </p>
        </div>
      </div>
    </footer>
  );
}
